module.exports = __webpack_public_path__ + "static/media/drinks.682f8aad.png";